import { FC } from "react";
import { useTranslation } from "react-i18next";

import {
  DirectionEnum,
  durationInMinutesCeil,
  NO_VALUE_DISPLAY,
} from "@ryde/shared";

import { BoardingSegmentDurationTooltipContent } from "./boarding-segment-duration-tooltip-content";
import { DurationLabelBoardingSegmentExceeded } from "./duration-label-boarding-segment-exceeded";
import { DurationLabelBoardingSegmentNormal } from "./duration-label-boarding-segment-normal";
import { useRideBoardingSegmentDurationLabel } from "./hooks/use-ride-boarding-segment-duration-label";

export const RideBoardingSegmentDurationLabel: FC = () => {
  const { t } = useTranslation();
  const {
    rideDto,
    effectiveMaxSegmentDurationInMinutes,
    boardingSegmentDurationMinutesCeil,
    isBoardingSegmentDurationExceeded,
    isVisible,
  } = useRideBoardingSegmentDurationLabel();

  if (!isVisible) {
    return null;
  }

  const totalRideDurationDisplayValue =
    durationInMinutesCeil(rideDto?.metadata?.totalDuration) || NO_VALUE_DISPLAY;
  const boardingSegmentDurationDisplayValue =
    boardingSegmentDurationMinutesCeil ?? NO_VALUE_DISPLAY;
  const maxSegmentDurationDisplayValue =
    effectiveMaxSegmentDurationInMinutes ?? NO_VALUE_DISPLAY;

  const boardingSegmentLabelKey =
    rideDto?.direction === DirectionEnum.DropOff
      ? "ride.formLabel.boardingSegmentDurationDropOffs"
      : "ride.formLabel.boardingSegmentDurationPickups";

  const displayContent = `${boardingSegmentDurationDisplayValue} ${t("general.MIN")} ${t(boardingSegmentLabelKey)}`;

  const tooltipContent = (
    <BoardingSegmentDurationTooltipContent
      direction={rideDto?.direction}
      boardingSegmentMinutes={boardingSegmentDurationDisplayValue}
      totalMinutes={totalRideDurationDisplayValue}
      maxMinutes={
        effectiveMaxSegmentDurationInMinutes &&
        effectiveMaxSegmentDurationInMinutes > 0
          ? maxSegmentDurationDisplayValue
          : undefined
      }
      isExceeded={isBoardingSegmentDurationExceeded}
    />
  );

  if (isBoardingSegmentDurationExceeded) {
    return (
      <DurationLabelBoardingSegmentExceeded
        boardingSegmentDurationDisplayValue={
          boardingSegmentDurationDisplayValue
        }
        maxSegmentDurationDisplayValue={maxSegmentDurationDisplayValue}
        displayContent={displayContent}
        tooltipContent={tooltipContent}
      />
    );
  }

  return (
    <DurationLabelBoardingSegmentNormal
      displayContent={displayContent}
      tooltipContent={tooltipContent}
    />
  );
};
